import { Component, OnInit, ViewChild } from '@angular/core';
import { GridViewComponent } from 'src/app/shared/components/grid-view/grid-view.component';
import { Listing } from 'src/app/shared/models/listing.model';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { Languages, SupplierAccountStatus, SupplierStatus, ArabicSupplierStatus } from 'src/app/shared/models/enums.model';
import { MenuItem } from '../../e-booking/agent-registration-request/offline-agent-list/offline-agent-list.component';
import { LookUp } from 'src/app/front-user/shared/models/look-up.model';
import { LookupService } from 'src/app/front-user/shared/services/lookup.service';
import { SupplierService } from 'src/app/shared/services/supplier.service';
import { DomSanitizer } from '@angular/platform-browser';
import { AppConfig } from 'src/app/shared/services/app.config';
import { Router } from '@angular/router';
import { EtenderService } from 'src/app/shared/services/etender.service';
import { ETenderAdminTypes } from 'src/app/shared/models/e-tender.model';
import { TranslateService } from '@ngx-translate/core';
import { fileService } from 'src/app/front-user/shared/services/file.service';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
@Component({
  selector: 'app-supplier-list',
  templateUrl: './supplier-list.component.html',
  styleUrls: ['./supplier-list.component.css']
})
export class SupplierListComponent implements OnInit {
  private collection: Listing;
  @ViewChild('SupplierList',{static: false}) gridView: GridViewComponent;
  AccountStatusId: number = null;
  SupplierTypeId: number = null;
  SupplierNumber: string ;
  CompanyName: string;
  CompanyEmail: string;
  TaxRecordNumber: string;
  RequestNumber: string;
  MobileNumber: string;
  category: number = null;
  selectedItems: number = null;
  pageSize = 10;
  IsHtml = false;
  HasMenu = true;
  hideExportButton: boolean;
  private itemsMenu: MenuItem[] = [];
  HasMenuButtons: Boolean = true;
  AccountStatus: LookUp[];
  SupplierTypes: LookUp[];
  SupplierCategories: LookUp[];
  displayedLang: string;
  isDeactivate = true;
  isActivate = true;
  isBlackListed = true;
  DomainUrl: string;
  public SupplierStatus: any = SupplierStatus;
  public ArabicSupplierStatus = ArabicSupplierStatus;
  currentUser: string;
  userGroups: number[] = [];
  isPurchasingCategoryAdmins = false;
  isRate = false;
  enabel = false;
  dropdownSettings = {};

  constructor(private global: GlobalServices, private supplierService: SupplierService,
              private lookupSrv: LookupService, private _router: Router,
              private etenderSrv: EtenderService, private translate: TranslateService,
              private authSrevice: AuthenticationService) {
    this.displayedLang = this.global.getLanguage() == Languages.Arabic ? 'ar' : 'en';
    this.DomainUrl = AppConfig.settings.apiServer.DomainAdminUrl;
    this.currentUser = this.authSrevice.currentUserValue.Email;
  //  this.currentUser = this.global.user.Email;
    this.getUserGroups();
    this.dropdownSettings = {
      singleSelection: true,
      idField: 'Id',
      textField: this.global.getLanguage() == Languages.Arabic ? 'NameAR' : 'NameEN',
      selectAllText: this.global.getLanguage() == Languages.Arabic ? 'أختر الكل' : 'Select All',
      unSelectAllText: this.global.getLanguage() == Languages.Arabic ? 'أحذف الكل' : 'UnSelect All',
      allowSearchFilter: true
    };
  }

  ngOnInit() {
    this.loadLookups();
    this.getUserGroups();
  }
  ExportExcel() {
    this.translate.get('ADMIN_USER.SUPPLIER_EXCEL_OBJECT').subscribe((response: string) => {
      this.supplierService.ExportSupplierExcel(JSON.stringify(response),
        (this.global.getLanguage() == Languages.Arabic ? 'Ar' : 'En'), this.AccountStatusId, this.SupplierTypeId, this.SupplierNumber,
        this.CompanyName,this.CompanyEmail,this.currentUser, this.category, this.TaxRecordNumber, this.RequestNumber, this.MobileNumber);
    });
  }
  getUserGroups() {
    this.etenderSrv.GetUserGroups(this.currentUser).subscribe(
      data => {
        this.userGroups = data.Data;
        if (this.userGroups.filter(a => a == ETenderAdminTypes.SCAServices_ETenderPurchasingCategoryAdmins).length > 0) {
          this.isPurchasingCategoryAdmins = true;
        }
        if (this.userGroups.filter(a => a == ETenderAdminTypes.SCAServices_ETenderTechnicalCategoryAdmins ||
          a == ETenderAdminTypes.SCAServices_ETenderPurchasingCategoryAdmins || ETenderAdminTypes.SCAServices_ETenderPurchasingDivisionManager || ETenderAdminTypes.SCAServices_ETenderTechnicalDivisionManagers).length > 0) {
          this.enabel = true;
        }
        if (this.userGroups.filter(a => a == ETenderAdminTypes.SCAServices_ETenderTechnicalCategoryAdmins).length > 0) {
          this.isRate = true;
        }
        if (this.enabel) {
          this.loadData();
        }
      },
      () => console.log('Something went wrong!!')
    );
  }

  // reset filteration data
  resetData() {
    this.AccountStatusId = null;
    this.SupplierTypeId = null;
    this.SupplierNumber = '';
    this.CompanyName = '';
    this.CompanyEmail = '';
    this.TaxRecordNumber = '';
    this.MobileNumber = '';
    this.RequestNumber = '';
    this.category = null;
    this.selectedItems = null;
    this.hideExportButton = false;
    this.loadData();
  }

  loadData() {
    this.SupplierTypeId = this.SupplierTypeId == null ? null : this.SupplierTypeId;
    this.AccountStatusId = this.AccountStatusId == null ? null : this.AccountStatusId;
    this.SupplierNumber = this.SupplierNumber == null ? '' : this.SupplierNumber;
    this.CompanyName = this.CompanyName == null ? '' : this.CompanyName;
    this.CompanyEmail = this.CompanyEmail == null ? '' : this.CompanyEmail;
    this.TaxRecordNumber = this.TaxRecordNumber == null ? '' : this.TaxRecordNumber;
    this.RequestNumber = this.RequestNumber == null ? '' : this.RequestNumber;
    this.MobileNumber = this.MobileNumber == null ? '' : this.MobileNumber;
    // this.category = this.category == null ? null : this.category;
    if (this.selectedItems != null){
    this.category = this.selectedItems[0].Id == null ? null : this.selectedItems[0].Id;
    }

    this.global.isLoaderEnabled = true;
    this.supplierService.GetSupplierPaged(0, this.pageSize, (this.global.getLanguage() == Languages.Arabic ? 'Ar' : 'En'),
     this.SupplierTypeId, this.AccountStatusId, this.SupplierNumber, this.CompanyName,this.CompanyEmail,this.currentUser,this.category, this.TaxRecordNumber, this.RequestNumber, this.MobileNumber).subscribe(

      d => {
        this.collection = d.Data;
        this.hideExportButton = this.collection.Collection.length > 0 ? false : true;
      },
      () => console.log('Something went wrong!!'),
      () => this.loadCollectionCompleted()

    );
  }

  loadCollectionCompleted() {
    // this.loadItemsMenu();
    this.gridView.loadGrid(this.collection, this.collection == null ? 0 : this.collection.TotalNumber, this.pageSize,
      'Supplier/GetAllReport?pageIndex={PAGEINDEX}&pageSize=' + this.pageSize +
      '&language=' + (this.global.getLanguage() == Languages.Arabic ? 'Ar' : 'En') +
      '&AccountStatusId=' + this.AccountStatusId + '&SupplierTypeId=' + this.SupplierTypeId +
      '&SupplierNumber=' + this.SupplierNumber + '&CompanyName=' + this.CompanyName +'&CompanyEmail='+this.CompanyEmail+'&currentUser=' + this.currentUser + '&catId=' + this.category
      +'&TaxRecordNumber=' + this.TaxRecordNumber + '&RequestNumber=' + this.RequestNumber + '&MobileNumber=' + this.MobileNumber,
      'SHARED.REPORTS.SUPPLIER_OBJECT', this.itemsMenu, '', '', 'GetAllReport');
    this.global.isLoaderEnabled = false;
  }

  // Get Lookups
  loadLookups() {
    // Get Supplier Account Statuses
    this.global.isLoaderEnabled = true;
    this.lookupSrv.getSupplierAccountStatuses().subscribe(d => {
      this.AccountStatus = d.Data.SupplierAccountStatuses;
      this.SupplierCategories = d.Data.Categories;
      this.global.isLoaderEnabled = false;
    });
    // Get Supplier Types
    this.global.isLoaderEnabled = true;
    this.lookupSrv.getSupplierTypes().subscribe(d => {
      this.SupplierTypes = d.Data;
      this.global.isLoaderEnabled = false;
    });
  }

  // loadItemsMenu(collection?: any) {
  //   const currentCollection = collection || this.collection.Collection;
  //   if (currentCollection.length > 0)
  //     currentCollection.forEach((key: any) => {

  //       key.Actions = this.sanitized.bypassSecurityTrustHtml(`<a  class='btn btn-primary SCAcustomBtn inverse-btn' href="${this.DomainUrl}rateSupplier/${key.RequestId}">Rate</a> `);
  //       if (key.AccountStatus === SupplierStatus.Activated) {

  //         key.Actions = this.sanitized.bypassSecurityTrustHtml(`<a  class='btn btn-primary SCAcustomBtn inverse-btn' href="${this.DomainUrl}rateSupplier/${key.RequestId}">Rate</a><a  class='btn btn-primary SCAcustomBtn inverse-btn' href="${this.DomainUrl}deactivateSupplier/${key.RequestId}/${SupplierAccountStatus.Disabled}">Disable</a><a  class='btn btn-primary SCAcustomBtn inverse-btn' href="${this.DomainUrl}deactivateSupplier/${key.RequestId}/${SupplierAccountStatus.BlackListed}">Black list</a>`);
  //         // key.Actions = this.sanitized.bypassSecurityTrustHtml(`<button type='button' onclick='alert()' class='btn btn-primary SCAcustomBtn inverse-btn' >Disabled</button> `);

  //         this.itemsMenu[0] = new MenuItem();
  //         this.itemsMenu[0].Title = "Deactivate";
  //         this.itemsMenu[0].TitleAr = "الغاء التفعيل";
  //       }
  //       else if (key.AccountStatus === SupplierStatus.Disabled) {
  //         key.Actions = this.sanitized.bypassSecurityTrustHtml(`<a  class='btn btn-primary SCAcustomBtn inverse-btn' href="${this.DomainUrl}rateSupplier/${key.RequestId}">Rate</a><a  class='btn btn-primary SCAcustomBtn inverse-btn' href="${this.DomainUrl}deactivateSupplier/${key.RequestId}/${SupplierAccountStatus.Activated}">Enable</a><a  class='btn btn-primary SCAcustomBtn inverse-btn' href="${this.DomainUrl}deactivateSupplier/${key.RequestId}/${SupplierAccountStatus.BlackListed}">Black list</a>`);

  //         this.itemsMenu[0] = new MenuItem();
  //         this.itemsMenu[0].Title = "Acitvate";
  //         this.itemsMenu[0].TitleAr = "تفعيل";
  //       } else if (key.AccountStatus === SupplierStatus.BlackListed) {
  //         key.Actions = this.sanitized.bypassSecurityTrustHtml(`<a  class='btn btn-primary SCAcustomBtn inverse-btn' href="${this.DomainUrl}rateSupplier/${key.RequestId}">Rate</a><a  class='btn btn-primary SCAcustomBtn inverse-btn' href="${this.DomainUrl}deactivateSupplier/${key.RequestId}/${SupplierAccountStatus.Activated}">Enable</a><a  class='btn btn-primary SCAcustomBtn inverse-btn' href="${this.DomainUrl}deactivateSupplier/${key.RequestId}/${SupplierAccountStatus.Activated}">Remove from blacklist</a>`);

  //         this.itemsMenu[0] = new MenuItem();
  //         this.itemsMenu[0].Title = "Acitvate";
  //         this.itemsMenu[0].TitleAr = "تفعيل";
  //       }


  //     });

  // }
  deactivateSupplier(SupplierId) {

    this.supplierService.DeActivateSupplier(SupplierId).subscribe(
      () => {
        alert('deactivated');
      }
    );
  }

  rateSupplier(RequestId) {
    this._router.navigateByUrl('/rateSupplier/' + RequestId);
  }
  disabledSupplier(RequestId) {
    const status = SupplierAccountStatus.Disabled;
    this._router.navigateByUrl('/deactivateSupplier/' + RequestId + '/' + status);

  }
  blackListSupplier(RequestId) {
    const status = SupplierAccountStatus.BlackListed;
    this._router.navigateByUrl('/deactivateSupplier/' + RequestId + '/' + status);
  }
  enableSupplier(RequestId) {
    const status = SupplierAccountStatus.Activated;
    this._router.navigateByUrl('/deactivateSupplier/' + RequestId + '/' + status);
  }
  editSupplier(item) {
    const navigateUrl = '/UpdateSupplier';
    const requestId = item.RequestId;
    const isAllCategories = true;
    // if(item.AccountStatus == SupplierStatus.Activated){
    //      isAllCategories = false;
    // }
    this._router.navigate([navigateUrl], { state: { data: { requestId, isAllCategories } } });


  }

}




